"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.And = void 0;

var lodash_1 = __importDefault(require("lodash"));

var Term_1 = require("../Term");

var util_1 = require("./util");

exports.And = new Term_1.Term('And', 'AND', 'and', {
  evaluate: function evaluate(tokens, index, ids) {
    var prev = util_1.getPrev(tokens, index);
    var next = util_1.getNext(tokens, index);
    var prevRes = lodash_1["default"].isBoolean(prev) ? prev : ids.includes(prev.value);
    var nextRes = lodash_1["default"].isBoolean(next) ? next : ids.includes(next.value);
    return prevRes && nextRes;
  }
});